import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const actionNetwork = defineConnector({
  identifier: "actionNetwork",
  name: "Action Network",
  tagLine: "Activist organizing platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://actionnetwork\\.org/api/v2/.*",
  auth: (app) =>
    headerAuth([{ name: "OSDI-API-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Action Network](https://actionnetwork.org/), go to **Start Organizing → Details → API & Sync** to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://actionnetwork.org/api/v2/events?per_page=1",
  },
});
